const selectedLocationRow = (id, name) => {
  return `<div class="flex justify-between cursor-pointer items-center p-1 border-b text-sm hover:bg-gray-200">
        <span data-action="click->shelter-diagnostics#openLocation"
              data-location-id="${id}"
              class="hover:underline">${name}</span>
        <a class="text-gray-400 hover:text-red-800 hover:text-xl cursor-pointer px-1"
           data-action="click->shelter-diagnostics#deselectLocation"
           data-deselect-id="${id}">&times;</a>
      </div>`
}

const selectedLocationPagination = (selectionPageValue, maxPage, remaining, nextDisabled, prevDisabled) => {
  const overflow = remaining > 0
    ? `<p class="text-xs text-right text-gray-500 mt-1">+${remaining} more</p>`
    : ''
  return `${overflow}<div class="flex justify-between items-center mt-2 pt-1 border-t">
        <a class="text-xs ${prevDisabled ? 'text-gray-300 pointer-events-none' : 'text-blue-600 hover:underline cursor-pointer'}"
           data-action="click->shelter-diagnostics#prevSelectionPage">Previous</a>
        <span class="text-xs text-gray-500">${selectionPageValue} / ${maxPage}</span>
        <a class="text-xs ${nextDisabled ? 'text-gray-300 pointer-events-none' : 'text-blue-600 hover:underline cursor-pointer'}"
           data-action="click->shelter-diagnostics#nextSelectionPage">Next</a>
      </div>`
}

export { selectedLocationRow, selectedLocationPagination }
